import { createContext, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';

import useFeatureToggle from '@guestyci/feature-toggle-fe/useFeatureToggle';

import FullPageLoader from 'components/FullPageLoader';
import { getCookie, setCookie } from 'utils/cookies';
import { COOKIE_POLICY_ACCEPTED } from 'constants/constants';
import useGetWebsiteSettings from 'hooks/useGetWebsiteSettings';
import { NEW_TRANSLATIONS_UI } from 'constants/featureToggleNames';

const WebsiteSettingsContext = createContext();

const WebsiteSettingsContextProvider = ({ children }) => {
  const [isFtLoading, isLanguagesFtEnabled] = useFeatureToggle(NEW_TRANSLATIONS_UI);
  const { locale } = useRouteMatch('/:locale')?.params || {};
  const language = isLanguagesFtEnabled ? locale : undefined;

  const cookiePolicy = getCookie(COOKIE_POLICY_ACCEPTED);
  const [cookiesPolicyAccepted, setCookiesPolicyAccepted] = useState(cookiePolicy);
  const { data: websiteSettings, isLoading } = useGetWebsiteSettings({ language, enabled: !isFtLoading });

  const setPolicyCookie = ({ name = COOKIE_POLICY_ACCEPTED, value = '' }) => {
    setCookiesPolicyAccepted(value);
    setCookie(name, value);
  };

  if (isLoading || isFtLoading) {
    return <FullPageLoader />;
  }
  return (
    <WebsiteSettingsContext.Provider
      value={{
        ...websiteSettings,
        cookiesPolicyAccepted,
        setCookiesPolicyAccepted,
        setPolicyCookie,
      }}
    >
      {children}
    </WebsiteSettingsContext.Provider>
  );
};

export { WebsiteSettingsContext };
export default WebsiteSettingsContextProvider;
